import PAGINATION from '@sdk/helpers/misc/pagination';

import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

export const USED_VEHICLES_READ_FORCE = 'usedVehicles/read/FORCE';

export const USED_VEHICLES_REMOVE_START = 'usedVehicles/remove/START';
export const USED_VEHICLES_REMOVE_SUCCESS = 'usedVehicles/remove/SUCCESS';
export const USED_VEHICLES_REMOVE_FAILURE = 'usedVehicles/remove/FAILURE';

export const INITIAL_VEHICLE_FILTERS = {
  _active: false,
  CRUDL_append: false,

  name: '',
  store_ids: [],
  active: 'true',

  sort: SORT_METHODS.created_at_desc.value,
  page: 1,
  per_page: PAGINATION.PER_PAGE,
};

const singleKey = 'vehicle';
const multipleKey = 'vehicles';

const multipleEndpoint = '/vehicles';
const singleEndpoint = '/vehicles/:id';

const usedVehicles = crudlModuleGenerator('usedVehicles', {
  customKeys: {
    create: singleKey,
    read: singleKey,
    update: singleKey,
    delete: singleKey,
    list: multipleKey,
  },
  customEndpoints: {
    create: multipleEndpoint,
    read: singleEndpoint,
    update: singleEndpoint,
    delete: singleEndpoint,
    list: multipleEndpoint,
    // list: `${multipleEndpoint}/published`,
  },
});

export default {
  ...usedVehicles,
  state: {
    ...usedVehicles.state,

    list: {
      ...usedVehicles.state.list,
      filters: {
        ...INITIAL_VEHICLE_FILTERS,
      },
    },

    remove: {
      error: null,
      loading: false,
      result: {},
    },
  },
  actions: {
    ...usedVehicles.actions,

    readForce({ commit }, payload) {
      return new Promise((resolve) => {
        commit(USED_VEHICLES_READ_FORCE, payload);

        resolve();
      });
    },

    remove({ commit }, payload) {
      commit(USED_VEHICLES_REMOVE_START);

      return new Promise((resolve, reject) => {
        client.put(`/vehicles/${payload.id}/remove_from_stock`, payload)
          .then((response) => {
            commit(USED_VEHICLES_REMOVE_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(USED_VEHICLES_REMOVE_FAILURE, error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    ...usedVehicles.mutations,

    [USED_VEHICLES_READ_FORCE](state, vehicle) {
      state.read.item = vehicle;
    },

    [USED_VEHICLES_REMOVE_START](state) {
      state.remove.error = null;
      state.remove.loading = true;
      state.remove.result = {};
    },
    [USED_VEHICLES_REMOVE_SUCCESS](state, response) {
      const result = response.data;

      if (state.list.items[result.vehicle.id]) {
        state.list.items[result.vehicle.id].active = false;
        state.list.items[result.vehicle.id].reason = result.vehicle.reason;
      }

      state.remove.error = null;
      state.remove.loading = false;
      state.remove.result = result;
    },
    [USED_VEHICLES_REMOVE_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.remove.error = details;
      state.remove.loading = false;
      state.remove.result = {};
    },
  },
};
